<template>
  <v-container fluid class="d-flex flex-column" >
    <v-tabs v-model="tab" grow show-arrows slider-color="#E9282A">
      <v-tab v-for="(tab, value) in tabs" :value="value" :disabled="tab.disabled" nuxt="true" :to="`/configuration/${value}`" 
      :class="{ 'selected-tab': tabIsSelected(value), 'unselected-tab': !tabIsSelected(value) }">
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <slot />
  </v-container>
</template>

<script setup lang="ts">
const tabs: { [key: string]: { title: string, disabled: boolean } } = {
  "device": { title: "Device", disabled: false },
  "location": { title: "Location", disabled: false },
  "alert": { title: "Alert", disabled: false },  
  // "setting": { title: "setting", disabled: false },
  // "profile": { title: "Profile", disabled: false },
}

  const route = useRoute();
  const tab = ref(route.path);
  const tabIsSelected = (value: string) => {
    return tab.value === value;
  };
</script>
<style scoped>
 .v-tabs,
.v-tab {
  font-family: 'Nunito Sans', sans-serif;
}

.selected-tab {
  color: #fff !important;
  background-color: #E9282A;
  font-weight: 700 !important;

}
.unselected-tab:hover {
  background-color: #eb9596 !important;
  color: #fff !important;
}
.unselected-tab {
  color: #808b95;
  font-weight: bold;
}
</style>
